// src/services/tiposPagoService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';
import { ConfiguracionPago } from './configuracionPagoService';

const API_URL = 'tipos-pago/';

export interface TipoPago {
    id: number;
    nombre: string;
    descripcion: string;
    activo: boolean;
    fecha_creado: string;
    configuracion_detail?: ConfiguracionPago;
}

// GET: Obtener todos los tipos de pago
export const fetchTiposPago = async (): Promise<TipoPago[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<TipoPago[]>(API_URL);
        return response.data;
    });
};

// NUEVO: Obtener tipos de pago permitidos por POS
export const fetchTiposPagoPorPos = async (posId: number): Promise<TipoPago[]> => {
    return handleRequestWithAuth(async () => {
        try {
            // Primero obtenemos el POS para ver sus tipos permitidos
            const posResponse = await axiosInstance.get(`puntos-de-venta/${posId}/`);
            const pos = posResponse.data;
            
            // Si el POS tiene tipos de pago permitidos, obtener solo esos
            if (pos.tipos_pago_permitidos && pos.tipos_pago_permitidos.length > 0) {
                // Obtenemos todos los tipos de pago y filtramos
                const response = await axiosInstance.get<TipoPago[]>(API_URL);
                const todosTipos = response.data;
                
                return todosTipos.filter(tipo => 
                    pos.tipos_pago_permitidos.includes(tipo.id) && tipo.activo
                );
            }
            
            // Si no tiene configurados, obtener todos los activos
            const response = await axiosInstance.get<TipoPago[]>(`${API_URL}?activo=true`);
            return response.data;
        } catch (error) {
            console.error('Error al obtener tipos de pago por POS:', error);
            // Si hay error, devolver todos los tipos de pago activos
            const response = await axiosInstance.get<TipoPago[]>(`${API_URL}?activo=true`);
            return response.data;
        }
    });
};

// POST: Crear nuevo tipo de pago
export const createTipoPago = async (data: {
    nombre: string;
    descripcion?: string;
    activo: boolean;
    configuracion_de_pago: number;
}): Promise<TipoPago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post<TipoPago>(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar tipo de pago
export const updateTipoPago = async (
    id: number,
    data: {
        nombre: string;
        descripcion?: string;
        activo: boolean;
        configuracion_de_pago: number;
    }
): Promise<TipoPago> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put<TipoPago>(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar
export const deleteTipoPago = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};